import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../js/IncludeManager'
import { BookMarkStore, Alert } from '../../js/ComponentManager'
/* 개발담당:양유빈
 * 화면기능:사입요청 공통 페이지
 * 세부설명:
*/

export class BuyerPopup extends Component {
    static displayName = BuyerPopup.name;

    constructor(props) {
        super(props);
        this.state = {
            WholeInfo: [],
            HeartOn: false,
            Retail_Memo: "",
            ReturnUseYn: "N",
            ButtonList:[],
            Title:"",
            Content: "",
            isReturn:"N",
            isOk: false
        };
        this.ref_BuyerPopup = React.createRef();
        this.handleSave_Click = this.handleSave_Click.bind(this);
        this.handleMemo_Change = this.handleMemo_Change.bind(this);
        this.handleCheck_Click = this.handleCheck_Click.bind(this);
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
    }
    //초기화
    componentDidMount() {
        this.setState({ Title: this.Uid_Type === 'SS' ? "사입요청 안내" : "픽업요청 안내" });
    }
    //HeartOn 사용하지 않음.
    async initWholeCode(whole_code, HeartOn) {
        try {
            
            let Data = await Big3Common.Get(`api/Common/Common/GetWholeCodeToWholeInfo/${whole_code}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const WholeInfo = DataList.WholeInfo;
                const hearton = DataList.BookmarkYn === "Y" ? true : false;
                const ReturnUseYn = DataList.ReturnUseYn;
                const ButtonList = DataList.ButtonList;
                this.setState({
                    WholeInfo: WholeInfo,
                    HeartOn: hearton,
                    Content: "",
                    Retail_Memo: "",
                    isReturn:"N",
                    ReturnUseYn: ReturnUseYn,
                    ButtonList: ButtonList
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("initWholeCode", e);
        }
        return false;
    }
    async handleSave_Click(whole_code) {
        try {
            const Model = {
                Whole_Code: whole_code,
                Retail_Memo: this.state.Retail_Memo,
                Return_yn: this.state.isReturn
            };
            
            const Data = await Big3Common.Post("api/MyPage/OrderMgr/RegisterOrderMgt", Model,true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Content: this.Uid_Type === 'SS' ? "사입요청 되었습니다." : "택배 요청 되었습니다." },
                    () => {
                        if (this.props.CallBack) {
                            this.props.CallBack(whole_code);
                        }
                    }
                );
            }
            else if (Data.codeName === Big3Common.ResultCode.Reduplication) {
                this.setState({ Content: this.Uid_Type === 'SS' ? "이미 사입요청이 등록되어 있습니다." : "이미 픽업요청이 등록되어 있습니다." })
            }
            else {
                this.setState({ Content: Data.message });
            }
            Big3Common.ModalAlert(bootstrap, "BuyerPopupAlert");
        }
        catch (e) {
            console.log("handleSave_Click", e);
        }
        return false;
    }
    handleMemo_Change(event) {
        const Value = event.target.value;
        this.setState({ Retail_Memo: Value });
    }
    //주문하기 체크박스 선택
    handleCheck_Click = (event, list) => {

        const selected = list.selected === "N" ? "Y" : "N";
        list.selected = selected;
        let isReturn = this.state.isReturn;
        if (list.memo_dtl_code === "OD" && selected === "Y") {
            isReturn = "Y";
        }
        const MessageList = this.state.ButtonList.filter(list => list.selected === "Y");
        const Retail_Memo = MessageList.map(list => { return list.content }).join(',');

        this.setState({ Retail_Memo: Retail_Memo, isReturn: isReturn });
        return false;
    }
    bookmarkrender(WholeInfo) {
        if (WholeInfo.length === 0) {
            return ("");
        }
        else {
            return (
                <BookMarkStore
                    Whole_Code={WholeInfo.whole_code}
                    HeartOn={this.state.HeartOn}
                    CheckCss={'shop_icon1_check'}
                    UnCheckCss={'shop_icon1'}
                />
            )
        }
        
    }
    Returnrender() {
        const ReturnUseYn = this.state.ReturnUseYn;
        const ButtonList = this.state.ButtonList;
        if (ReturnUseYn === undefined || ReturnUseYn === "" || ReturnUseYn === "N") {
            return ("");
        }
        if (ButtonList.length === 0) {
            return ("");
        }
        return(
            <div className="modal_input_btn_box">
                <ul className="check_btns">
                    {ButtonList.map(list =>
                        <li key={list.memo_dtl_code}>
                            <input type="checkbox" id={list.memo_dtl_code}
                                checked={list.selected === "Y" ? true : false}
                                onChange={() => { return false; }}
                                className="btn type02"
                            />
                            <label htmlFor={list.memo_dtl_code} onClick={(e) => { this.handleCheck_Click(e, list) }}>{list.content}</label>
                        </li>
                    )}                     
                </ul>
            </div>
        )
    }
    render() {
        const WholeInfo = this.state.WholeInfo.length === 0 ? [] : this.state.WholeInfo[0];
        const bookmarkrender = this.bookmarkrender(WholeInfo);
        const Returnrender = this.Returnrender();
        return (
            <div ref={this.ref_BuyerPopup} className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id} data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered ">
                    <div className="modal-content ordertype_modal">
                        <div className="modal-body text-center ">
                            <div className="category_slectbox">
                                <div className="title_info">
                                    <div className="title">{WholeInfo.whole_name || "" }</div>
                                    <div className="shop_icon">
                                        {bookmarkrender }
                                        <div className="shop_icon2"
                                            onClick={() => {
                                                Big3Common.Util.SmsSend(WholeInfo.whole_phone, this.state.Retail_Memo);
                                            }}
                                        ></div>
                                        <div className="shop_icon3" onClick={() => { window.location.href = `tel:${WholeInfo.whole_phone}` }}></div>
                                    </div>
                                </div>
                                <div className="shop_address">{`${WholeInfo.bld_name} ${WholeInfo.flr_name}층 ${WholeInfo.whole_no_name}호` || ""}</div>
                                {Returnrender }
                                <div className="info_txt">{this.Uid_Type === 'SS' ? "사입요청은 도매매장에 전달 되지 않습니다." : "픽업요청은 도매매장에 전달 되지 않습니다."}</div>
                                <div className="textarea_box">
                                    <textarea className="form-control"
                                        value={this.state.Retail_Memo}
                                        onChange={this.handleMemo_Change}
                                        placeholder={this.Uid_Type === 'SS' ? "사입삼촌에게 전달사항이 있으면 써주세요." : "택배삼촌에게 전달사항이 있으면 써주세요."}>
                                    </textarea>
                                </div>
                            </div>
                            {this.Uid_Type === 'SS' ? (
                                <div className="ok_btn_box">
                                    <button onClick={() => { this.handleSave_Click(WholeInfo.whole_code) }}>사입요청</button>
                                </div>
                            ) : (
                                <div className="ok_btn_box">
                                    <button onClick={() => { this.handleSave_Click(WholeInfo.whole_code) }}>픽업요청</button>
                                </div>
                            )}
                            <button type="button" className="btn-close"
                                onClick={() => {
                                    Big3Common.ModalClose(bootstrap, "BuyerPopup");
                                    if (this.props.CallBack !== undefined) {
                                        this.props.CallBack();
                                    }
                                }}
                            ></button>
                        </div>
                    </div>
                </div>
                <Alert
                    id="BuyerPopupAlert"
                    content={this.state.Content}
                    title={this.state.Title}
                    AlertClick={() => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, "BuyerPopup");
                        }, 500);
                        
                    }}
                />
            </div>
        );
    }
}
